export const domEventTypes = {
    click: `click`,
    hover: "hover",
    mouseleave: "mouseleave",
};



//////////////////
// WEBPACK FOOTER
// ./~/@celine/passive-tracking/dist/types/dom-events.js
// module id = ./node_modules/@celine/passive-tracking/dist/types/dom-events.js
// module chunks = 0